/*
 * function clickAsLink(url, event)
 *
 * Allows treating a click event as if a hyperlink was clicked.
 * Opens a new tab or window if a modifier key is pressed.
 */
export const clickAsLink = (window, url, event) => {
  if (event.shiftKey || event.ctrlKey || event.metaKey) {
    window.open(url);
  } else {
    window.location.assign(url);
  }
};

/*
 * function openInNewTab(url)
 *
 * Opens a URL in a new tab from a later task. Chrome takes the new window's disposition from the
 * modifier keys on the input event it is dispatching, and Cmd+Opt (Ctrl+Alt on Windows and Linux)
 * means split view. A later task carries no input event.
 */
export const openInNewTab = (url) => {
  setTimeout(() => window.open(url), 0);
};
